// Kamera: jedna jawna transformacja swiat (metry, os Y w gore) <-> ekran (px, os Y w dol).

export class Camera {
  /** Piksele na metr. */
  scale = 150;
  /** Srodek widoku w ukladzie swiata (metry). */
  centerX = 1.6;
  centerY = 0.75;
  width = 1;
  height = 1;

  resize(width: number, height: number): void {
    this.width = width;
    this.height = height;
  }

  worldToScreen(x: number, y: number): { x: number; y: number } {
    return {
      x: (x - this.centerX) * this.scale + this.width / 2,
      y: this.height / 2 - (y - this.centerY) * this.scale,
    };
  }

  screenToWorld(screenX: number, screenY: number): { x: number; y: number } {
    return {
      x: (screenX - this.width / 2) / this.scale + this.centerX,
      y: this.centerY - (screenY - this.height / 2) / this.scale,
    };
  }

  /** Metry na piksel - do progow przyciagania wyrazonych w pikselach. */
  get metersPerPixel(): number {
    return 1 / this.scale;
  }
}
